/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
/**
 * A helper method for creating a context key with the appropriate type
 *
 * @param key a context key value
 * @returns the context key value with the correct type
 */
export function createContext(key) {
    return key;
}
//# sourceMappingURL=context-key.js.map